module.exports = __webpack_public_path__ + "img/boas-vindas-delivery.935ceadd.jpg";